import { FormControl, FormLabel } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import CurrencyInput, { CurrencyInputProps } from "react-currency-input-field";
import colors from "utils/colors";
import { getCustomCurrency } from "utils/uiconfighelper";

const variants: {
  [key: string]: any;
} = {
  default: {
    background: "white",
    borderWidth: "1.5px",
    borderColor: colors.GRAY_50,
    borderRadius: "7px",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    height: "2.5rem",
    width: "100%",
  },
  cell: {
    background: "#F9F8F8",
    borderRadius: "5px",
    padding: "5px 10px",
    textAlign: "right",
    fontSize: "1rem",
    height: "2.5rem",
    color: colors.SECONDARY,
  },
  scenario: {
    padding: "6px 15px",
    borderRadius: "5px",
    background: "#F9F8F8",
    fontSize: "14px",
    textAlign: "right",
    height: "36px",
    color: colors.SECONDARY,
    width: "100%",
  },
};

interface MoneyInputProps extends CurrencyFieldProps {
  label?: string;
}

export default function MoneyField({
  label,
  isInvalid,
  disabled,
  variant = "default",
  cy,
  allowNegativeValue = false,
  ...props
}: MoneyInputProps) {
  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <MoneyInput
        cy={cy}
        allowNegativeValue={allowNegativeValue}
        disabled={disabled}
        variant={variant}
        isInvalid={isInvalid}
        {...props}
      />
    </FormControl>
  );
}

interface CurrencyFieldProps extends CurrencyInputProps {
  isInvalid?: boolean;
  disabled?: boolean;
  variant?: string;
  cy?: string;
  allowNegativeValue?: boolean;
}

export function MoneyInput({
  cy,
  allowNegativeValue = false,
  disabled,
  variant = "default",
  isInvalid,
  ...props
}: CurrencyFieldProps) {
  const { user } = useTenant();
  const custom_currency = getCustomCurrency(user);

  return (
    <CurrencyInput
      width="100%"
      data-cy={cy}
      placeholder={custom_currency ? `${custom_currency}0.00` : "$0.00"}
      allowNegativeValue={allowNegativeValue}
      decimalsLimit={2}
      prefix={custom_currency ? `${custom_currency}` : "$"}
      decimalScale={2}
      disabled={disabled}
      style={{
        ...variants[variant],
        borderColor: isInvalid ? "red" : variants[variant].borderColor,
        color: disabled ? "gray" : variants[variant].color,
      }}
      {...props}
    />
  );
}
